import {translations} from 'presentation/translations-new';
import {formatAddress} from 'presentation/utils';
import {GetAddressDescriptionParams} from './types';

const {registeredPlural} = translations['pt-br'].commons;

export function getAddressDescription({
	contactsAddress,
	favoriteAddresses,
	isLoading = false,
	loadingLabel = '',
}: GetAddressDescriptionParams): string {
	if (isLoading) return loadingLabel;

	const favorites = favoriteAddresses ?? [];

	if (favorites.length > 1) {
		return `${favorites.length} ${registeredPlural.toLocaleLowerCase()}`;
	}

	if (favorites.length === 1) {
		const fav = favorites[0].address;
		return formatAddress({
			address: fav.nmLogradouro.replace(/^(\w+)\s/, '$1. '),
			number: `${fav.nuEndereco}`,
			complement: fav.dsComplemento,
			district: fav.nmBairro,
			city: fav.nmCidade,
			state: fav.nmUf,
			zipCode: fav.nuCep,
		});
	}

	if (!contactsAddress) return '';

	return formatAddress({
		type: contactsAddress.nmTipoLogradouro,
		address: contactsAddress.nmRua,
		number: contactsAddress.nuEndereco ? `${contactsAddress.nuEndereco}` : '',
		complement: contactsAddress.dsComplemento,
		district: contactsAddress.nmBairro,
		city: contactsAddress.nmCidade,
		state: contactsAddress.nmUf,
		zipCode: contactsAddress.nuCep,
	});
}

export type {GetAddressDescriptionParams};
